<template>
  <v-dialog
    v-model="show"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    scrollable
    persistent
    :width="getDialogWidthClass"
  >
    <v-card height="auto" elevation="5" class="rounded-lg" min-height="200">
      <v-card-title class="text-h5 lighten-2">Notificación OP</v-card-title>
      <v-card-text>
        <v-container>
          <v-form ref="formNotification" lazy-validation>
            <v-row no-gutters>
              <v-col cols="12">
                <v-combobox
                  label="Selecciona tipo de notificación"
                  dense
                  outlined
                  clearable
                  :rules="validation()"
                  type="text"
                  v-model="event"
                  :items="notifications"
                ></v-combobox>
              </v-col>
            </v-row>
            <v-row v-if="event && event.value == 'update'">
              <v-col cols="12" v-if="notNotifyEvent.length > 0" align="end">
                <v-btn color="primary" rounded @click="clearListEvent">
                  <v-icon> mdi- </v-icon>
                  Revertir lista eventos
                </v-btn>
              </v-col>
              <v-col>
                <v-data-table
                  fixed-header
                  height="300px"
                  :headers="headers"
                  :items="events"
                  :items-per-page="10"
                  no-data-text="No hay cambios"
                  loading-text="Cargando cambios..."
                  :page.sync="page"
                  hide-default-footer
                  :loading="fetchingData"
                  :item-class="row_classes"
                >
                  <template #[`item.event_before`]="{ item }">
                    <span>{{ item.event_before }}</span>
                  </template>
                  <!-- <template #[`item.actions`]="{ item }">
                    <v-icon @click="removeEvent(item)"> mdi-close</v-icon>
                  </template> -->
                </v-data-table>
                <v-pagination
                  v-model="page"
                  :length="numPages"
                  total-visible="10"
                  color="primary"
                ></v-pagination>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-container>
          <v-row>
            <v-col>
              <v-btn
                color="red"
                block
                @click="closeModal()"
                dark
                :disabled="isLoading"
                >Cancelar</v-btn
              >
            </v-col>
            <v-col>
              <v-btn
                color="primary"
                block
                @click="confirmation"
                :loading="isLoading"
                >Enviar notificación</v-btn
              >
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
//validations
import { requiredValidation } from "@/helpers/validations.js";
//vuex
import { mapActions, mapState } from "vuex";
export default {
  data: () => ({
    notNotifyEvent: [],
    event: null,
    notifications: [
      { text: "Nueva OP", value: "new" },
      { text: "Actualización OP", value: "update" },
    ],
    headers: [
      {
        text: "Nombre",
        align: "center",
        value: "name",
        sortable: false,
      },
      {
        text: "Ahora",
        align: "center",
        value: "event_now",
        sortable: false,
      },
      {
        text: "Antes",
        align: "center",
        value: "event_before",
        sortable: false,
      },
      { text: "Acciones", align: "center", value: "actions", sortable: false },
    ],
    isLoading: false,
    events: [],
    page: 1,
    numPages: 1,
    fetchingData: false,
  }),
  props: {
    value: Boolean,
  },
  computed: {
    getDialogWidthClass() {
      if (this.$vuetify.breakpoint.xl) {
        return "80%";
      } else if (this.$vuetify.breakpoint.lg) {
        return "100%";
      } else {
        return "100%";
      }
    },
    ...mapState("order", ["orderToUpdate"]),
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    row_classes(value) {
      if (value.clicked) {
        return "custom-highlight-row";
      }
    },
    ...mapActions("order", [
      "getDeliverytOrders",
      "updateOP",
      "sendNotificationLoteEvent",
      "getEvents",
    ]),
    closeModal() {
      this.show = false;
    },
    async confirmation() {
      if (this.$refs.formNotification.validate()) {
        try {
          this.isLoading = true;
          let payload = {
            eventType: this.event.value,
            order: this.orderToUpdate._id,
            notNotifyEvent: this.notNotifyEvent,
          };
          console.log(payload);
          let response = await this.sendNotificationLoteEvent(payload);
          if (!response) throw response;
          this.$swal({
            icon: "success",
            title: `Notificación enviada`,
            showConfirmButton: false,
            timer: 2000,
          });
          this.show = false;
        } catch (e) {
          console.log(e);
          this.$swal({
            icon: "error",
            title: `Algo salio mal al notificar OP`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
        this.isLoading = false;
      }
    },
    validation(name) {
      return requiredValidation(name);
    },
    async removeEvent(item) {
      this.notNotifyEvent.push(item);
      await this.fetchEvents();
    },
    async clearListEvent() {
      this.notNotifyEvent = [];
      await this.fetchEvents();
    },
    async fetchEvents() {
      this.fetchingData = true;
      try {
        let payload = {
          order: this.orderToUpdate._id,
          page: this.page,
          notNotifyEvent: this.notNotifyEvent,
        };
        let response = await this.getEvents(payload);
        if (!response) throw response;
        this.events = response.events;
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al cargar eventos`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
      this.fetchingData = false;
    },
  },
  watch: {
    async event(val) {
      if (val) {
        if (val.value == "update") {
          await this.fetchEvents();
        }
      }
    },
    async page() {
      await this.fetchEvents();
    },
  },
};
</script>

<style scoped>
.decrease {
  background-color: red;
  color: white;
}
</style>
